var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettlementArrowRightDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.64 7.5C10.7747 7.50051 10.9079 7.52824 11.0316 7.58151C11.1554 7.63478 11.2671 7.7125 11.36 7.81L15.22 11.81C15.4032 11.9969 15.5059 12.2482 15.5059 12.51C15.5059 12.7718 15.4032 13.0231 15.22 13.21L11.22 17.21C11.1268 17.3032 11.0161 17.3772 10.8943 17.4277C10.7724 17.4781 10.6419 17.5041 10.51 17.5041C10.3781 17.5041 10.2476 17.4781 10.1258 17.4277C10.0039 17.3772 9.89324 17.3032 9.8 17.21C9.70676 17.1168 9.6328 17.0061 9.58234 16.8842C9.53188 16.7624 9.50591 16.6319 9.50591 16.5C9.50591 16.3681 9.53188 16.2376 9.58234 16.1157C9.6328 15.9939 9.70676 15.8832 9.8 15.79L13.1 12.5L9.92 9.2C9.73375 9.01263 9.62921 8.75919 9.62921 8.495C9.62921 8.23081 9.73375 7.97736 9.92 7.79C10.0146 7.69611 10.1271 7.62209 10.2507 7.57229C10.3744 7.52249 10.5067 7.49791 10.64 7.5Z",
    fill: "#DBDCDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettlementArrowRightDisable);
export default __webpack_public_path__ + "static/media/icon_settlement_arrow_right_disable.8db5644ce0bf42a94306e6f4ad580ef5.svg";
export { ForwardRef as ReactComponent };